<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12" class="pa-0">
        <s-crud
          ref="crud"
          edit
          height="auto"
          searchInput
          :config="config"
          :filter="filter"
          title="Mis Estimaciones de Planning Poker (Vista Programador)"
          dialog-width="950"
          @rowSelected="rowSelected($event)"
          @getDataRefresh="onDataRefresh"
        >
          <!-- Filtros de la Grilla -->
          <template v-slot:filter>
            <v-container fluid class="py-3 px-4">
              <v-row dense align="center">
                <v-col cols="12" sm="6">
                  <s-text label="Título de la Historia" v-model="filter.UsoTitle" clearable></s-text>
                </v-col>
                <v-col cols="12" sm="6">
                  <s-select-definition label="Estado" :def="1721" v-model="filter.UsoStatus" clearable></s-select-definition>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <!-- Formulario Modal de Edición (Votación del Programador) -->
          <template scope="props">
            <v-container fluid class="pa-4">
              <!-- Resumen de la Historia (Solo Lectura) -->
              <v-card outlined class="mb-5 pa-4 grey lighten-5 rounded-lg">
                <div class="d-flex align-center mb-3">
                  <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                  <span class="text-subtitle-1 font-weight-bold primary--text">Detalle de la Historia de Usuario (Solo Lectura)</span>
                </div>
                <v-row dense>
                  <v-col cols="12" sm="3">
                    <s-text label="Código Historia" v-model="props.item.UsoCode" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-text label="Requerimiento" v-model="props.item.ReqCode" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-text label="Proyecto" v-model="props.item.ReqProject" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-text label="Puntaje Inicial" v-model="props.item.ReqInitialScore" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12">
                    <s-textarea label="Historia de Usuario" v-model="props.item.UsoTitle" readonly disabled></s-textarea>
                  </v-col>
                  <v-col cols="12">
                    <s-textarea label="Criterios de Aceptación" v-model="props.item.UsoAcceptanceCriteria" readonly disabled></s-textarea>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Aviso de votación cerrada -->
              <v-alert
                v-if="props.item.UsoConsensusConfirmed"
                type="success"
                text
                class="mb-4"
                icon="mdi-check-decagram"
              >
                <strong>Votación cerrada:</strong> se alcanzó el consenso para esta historia
                <template v-if="props.item.UsoFinalSizeName">
                  ({{ props.item.UsoFinalSizeName }} · {{ props.item.UsoStoryPoints }} pts)
                </template>
                . Ya no es posible votar.
              </v-alert>

              <!-- Sección de Registro de Voto -->
              <v-card outlined class="pa-4 indigo lighten-5 rounded-lg border-indigo">
                <div class="d-flex align-center mb-3">
                  <v-icon color="indigo darken-2" class="mr-2">mdi-cards-variant</v-icon>
                  <span class="text-subtitle-1 font-weight-bold indigo--text text--darken-2">Registrar / Modificar Mi Voto de Planning Poker</span>
                </div>

                <v-row dense align="center">
                  <v-col cols="12" sm="7">
                    <s-select-definition
                      label="Mi Talla de Estimación (T-Shirt Size) *"
                      :def="1724"
                      v-model="myVoteSize"
                      clearable
                      :disabled="props.item.UsoConsensusConfirmed"
                    ></s-select-definition>
                  </v-col>
                  <v-col cols="12" sm="5" class="d-flex align-center">
                    <v-btn
                      block
                      large
                      color="indigo"
                      dark
                      class="font-weight-bold"
                      :loading="savingVote"
                      :disabled="props.item.UsoConsensusConfirmed"
                      @click="submitVote(props.item)"
                    >
                      <v-icon left>mdi-check-decagram</v-icon> Guardar Mi Voto
                    </v-btn>
                  </v-col>
                </v-row>

                <div v-if="myVoteSizeName" class="mt-3 d-flex align-center">
                  <v-icon small color="green darken-1" class="mr-1">mdi-check-circle</v-icon>
                  <span class="text-caption font-weight-bold green--text text--darken-2">
                    Actualmente has votado por: {{ myVoteSizeName }}
                  </span>
                </div>
              </v-card>
            </v-container>
          </template>

          <!-- Custom Slots para Grilla -->
          <template v-slot:item.UsoStatusName="{ item }">
            <v-chip
              small
              :color="statusColor(item.UsoStatus)"
              dark
              class="font-weight-bold"
            >
              {{ item.UsoStatusName || 'En Refinamiento' }}
            </v-chip>
          </template>

          <template v-slot:item.ReqProject="{ item }">
            <v-chip
              v-if="item.ReqProject"
              x-small
              color="teal lighten-5"
              class="teal--text text--darken-3 font-weight-bold"
            >
              {{ item.ReqProject }}
            </v-chip>
            <span v-else class="grey--text text--caption">Sin Proyecto</span>
          </template>

          <template v-slot:ReqProject="{ row }">
            <v-chip
              v-if="row.ReqProject"
              x-small
              color="teal lighten-5"
              class="teal--text text--darken-3 font-weight-bold"
            >
              {{ row.ReqProject }}
            </v-chip>
            <span v-else class="grey--text text--caption">Sin Proyecto</span>
          </template>

          <template v-slot:item.MyVoteStatus="{ item }">
            <v-chip
              v-if="myVotesMap[item.UsoID]"
              small
              color="indigo lighten-5"
              class="indigo--text text--darken-3 font-weight-bold"
            >
              <v-icon x-small left color="indigo darken-2">mdi-check-circle</v-icon>
              {{ myVotesMap[item.UsoID].sizeName }}
            </v-chip>
            <v-chip
              v-else-if="item.UsoConsensusConfirmed"
              small
              color="grey lighten-3"
              class="grey--text text--darken-1 font-weight-bold"
            >
              No votaste
            </v-chip>
            <v-chip
              v-else
              small
              color="amber lighten-4"
              class="brown--text text--darken-2 font-weight-bold"
            >
              <v-icon x-small left color="amber darken-3">mdi-clock-outline</v-icon>
              Pendiente
            </v-chip>
          </template>

          <template v-slot:MyVoteStatus="{ row }">
            <v-chip
              v-if="myVotesMap[row.UsoID]"
              small
              color="indigo lighten-5"
              class="indigo--text text--darken-3 font-weight-bold"
            >
              <v-icon x-small left color="indigo darken-2">mdi-check-circle</v-icon>
              {{ myVotesMap[row.UsoID].sizeName }}
            </v-chip>
            <v-chip
              v-else-if="row.UsoConsensusConfirmed"
              small
              color="grey lighten-3"
              class="grey--text text--darken-1 font-weight-bold"
            >
              No votaste
            </v-chip>
            <v-chip
              v-else
              small
              color="amber lighten-4"
              class="brown--text text--darken-2 font-weight-bold"
            >
              <v-icon x-small left color="amber darken-3">mdi-clock-outline</v-icon>
              Pendiente
            </v-chip>
          </template>

          <template v-slot:item.UsoConsensusConfirmed="{ item }">
            <v-chip
              small
              :color="item.UsoConsensusConfirmed ? 'green' : 'orange'"
              dark
              class="font-weight-bold"
            >
              {{ item.UsoConsensusConfirmed ? 'Cerrada' : 'Abierta' }}
            </v-chip>
          </template>

          <template v-slot:UsoStatusName="{ row }">
            <v-chip
              small
              :color="statusColor(row.UsoStatus)"
              dark
              class="font-weight-bold"
            >
              {{ row.UsoStatusName || 'En Refinamiento' }}
            </v-chip>
          </template>

          <template v-slot:UsoConsensusConfirmed="{ row }">
            <v-chip
              small
              :color="row.UsoConsensusConfirmed ? 'green' : 'orange'"
              dark
              class="font-weight-bold"
            >
              {{ row.UsoConsensusConfirmed ? 'Cerrada' : 'Abierta' }}
            </v-chip>
          </template>
        </s-crud>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _sUserStoryService from '@/services/InformationTechnology/TicUserStoryService.js';
import sTextarea from '@/components/Utils/sTextarea.vue';
import { statusColor } from './statusColors.js';

export default {
  name: "MyEstimations",
  components: { sTextarea },
  data() {
    return {
      myVoteSize: null,
      myVoteSizeName: "",
      savingVote: false,
      myVotesMap: {},
      filter: {
        UsoTitle: "",
        UsoStatus: 2 // Por defecto historias en estimación (votación abierta)
      },
      config: {
        model: {
          UsoID: "ID",
          UsoStatus: "number",
          UsoConsensusConfirmed: "boolean",
          UsoStatusName: "string"
        },
        service: _sUserStoryService,
        headers: [
          { text: "Código Historia", value: "UsoCode", width: "130px" },
          { text: "Historia de Usuario", value: "UsoTitle", width: "260px" },
          { text: "Requerimiento", value: "ReqCode", width: "130px" },
          { text: "Proyecto", value: "ReqProject", width: "160px" },
          { text: "Puntos Historia", value: "UsoStoryPoints", align: "center", width: "130px" },
          { text: "Estado", value: "UsoStatusName", align: "center", width: "150px" },
          { text: "Mi Voto", value: "MyVoteStatus", align: "center", width: "160px" },
          { text: "Votación", value: "UsoConsensusConfirmed", align: "center", width: "120px" }
        ]
      }
    };
  },
  methods: {
    statusColor(status) {
      return statusColor(status);
    },
    async onDataRefresh(items) {
      if (!items || items.length === 0) return;
      const currentUserID = Number(this.$fun.getUserID());
      const promises = items.map(story =>
        _sUserStoryService.getVotes(story.UsoID, currentUserID)
          .then(res => {
            const votes = res.data || [];
            const myVote = votes.find(v => v.UsrID === currentUserID);
            if (myVote) {
              this.$set(this.myVotesMap, story.UsoID, {
                size: myVote.VoteSize,
                sizeName: myVote.VoteSizeName || `Talla ${myVote.VoteSize}`
              });
            } else {
              this.$set(this.myVotesMap, story.UsoID, null);
            }
          })
          .catch(() => {
            this.$set(this.myVotesMap, story.UsoID, null);
          })
      );
      await Promise.all(promises);
    },
    rowSelected(selection) {
      // s-crud emite un array con las filas seleccionadas
      const item = Array.isArray(selection) ? (selection.length > 0 ? selection[0] : null) : selection;
      if (item && item.UsoID) {
        this.myVoteSize = null;
        this.myVoteSizeName = "";
        const currentUserID = Number(this.$fun.getUserID());

        // Consultar los votos existentes para verificar si este programador ya votó
        _sUserStoryService.getVotes(item.UsoID, currentUserID).then(res => {
          const votes = res.data || [];
          const myVote = votes.find(v => v.UsrID === currentUserID);
          if (myVote) {
            this.myVoteSize = myVote.VoteSize;
            this.myVoteSizeName = myVote.VoteSizeName || `Talla ${myVote.VoteSize}`;
            this.$set(this.myVotesMap, item.UsoID, {
              size: myVote.VoteSize,
              sizeName: this.myVoteSizeName
            });
          }
        }).catch(() => {
          this.myVoteSize = null;
        });
      }
    },

    closeForm() {
      const crud = this.$refs.crud;
      if (crud) {
        if (crud.$refs.toolbar && typeof crud.$refs.toolbar.cancel === "function") {
          crud.$refs.toolbar.cancel();
        } else {
          crud.showForm = false;
        }
      }
    },

    submitVote(item) {
      if (item && item.UsoConsensusConfirmed) {
        this.$fun.alert("La votación de esta historia ya fue cerrada. No se pueden registrar más votos.", "warning");
        return;
      }

      if (!this.myVoteSize) {
        this.$fun.alert("Por favor seleccione una Talla para su voto", "warning");
        return;
      }

      if (!item || !item.UsoID) {
        this.$fun.alert("Ocurrió un problema con la historia seleccionada", "error");
        return;
      }

      const currentUserID = Number(this.$fun.getUserID());
      const selectedSize = Number(this.myVoteSize);
      const votePayload = {
        UsoID: item.UsoID,
        UsrID: currentUserID,
        VoteSize: selectedSize,
        UsrUpdateID: currentUserID
      };

      this.savingVote = true;
      _sUserStoryService.saveVote(votePayload, currentUserID).then(() => {
        this.savingVote = false;
        this.$fun.alert("¡Su voto de Planning Poker se ha registrado exitosamente!", "success");

        // Actualizar el mapa local inmediatamente para reflejar el voto en la grilla
        this.$set(this.myVotesMap, item.UsoID, {
          size: selectedSize,
          sizeName: this.myVoteSizeName || `Talla ${selectedSize}`
        });

        // Cerrar el formulario de edición/modal
        this.closeForm();

        // Refrescar los datos de la grilla en segundo plano
        if (this.$refs.crud) {
          this.$refs.crud.refresh();
        }
      }).catch(error => {
        this.savingVote = false;
        this.$fun.alert(error?.response?.data?.Message || "Error al registrar el voto", "error");
      });
    }
  }
};
</script>

<style scoped>
.border-indigo {
  border: 1px solid #c5cae9 !important;
}
</style>
